import React, { useState } from "react";
import { useParams } from "react-router-dom";
//primeReact
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
//services
import { PanelCreateBlock } from "./PanelCreateBlock";
import { PanelCreateLand } from "./PanelCreateLand";
import { useAppContext } from "../../../../context/AppContext";

const ModalCreateLands = ({
  visible,
  headerModal,
  handleCloseModal,
  blocks,
  refetch,
  refresh,

}) => {
  const { id } = useParams(); //get id
  const { nomenclatures, permissions } = useAppContext();

  const nomenclature = JSON.parse(nomenclatures);

  const [loading, setLoading] = useState(false);

  return (
    <>
      <Dialog
        id="modal_cad"
        className="rounded-4"
        visible={visible}
        header={headerModal}
        onHide={handleCloseModal}
        style={{ width: window.innerWidth <= 992 ? "90vw" : "85vw", }} 
        draggable={false}
      >

        <TabView>
          {permissions && permissions.includes("93") && ( //Cadastrar Quadra e Lote
            <TabPanel header={`${nomenclature[0].value}`}>
              <PanelCreateBlock
                loading={loading}
                setLoading={setLoading}
                id={id}
                refetch={refetch}
                refresh={refresh}
              />
            </TabPanel>
          )}

          {permissions && permissions.includes("93") && ( //Cadastrar Quadra e Lote
            <TabPanel header={`${nomenclature[1].value}`}>
              <PanelCreateLand
                blocks={blocks}
                refetch={refetch}
                refresh={refresh}
              />
            </TabPanel>
          )}
        </TabView>
      </Dialog>
    </>
  );
};

export default ModalCreateLands;
